<template>
  <!-- 要事 -->
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        :disabled="tableData.length >= 10"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        :label="`${queryParams.months}月要事计划`"
        align="center"
      >
        <!-- 要事类别 -->
        <el-table-column
          prop="somethingImportantType"
          label="要事类别"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'somethingImportantType' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.somethingImportantType"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.somethingImportantType }}
            </div>
          </template>
        </el-table-column>
        <!-- 工作项 -->
        <el-table-column
          prop="workItem"
          label="工作项"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'workItem' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.workItem"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.workItem }}
            </div>
          </template>
        </el-table-column>
        <!-- 完成日期 -->
        <el-table-column
          prop="completionDate"
          label="完成日期"
          min-width="110px"
          align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-if="
                editField === 'completionDate' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.completionDate"
              type="date"
              value-format="MM-dd"
              format="MM-dd"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @change="confirmEdit"
            >
            </el-date-picker>
            <div v-else>
              {{ scope.row.completionDate }}
            </div>
          </template>
        </el-table-column>
        <!-- 交付物 -->
        <el-table-column
          prop="deliverables"
          label="交付物"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'deliverables' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.deliverables"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.deliverables }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :label="`${queryParams.months}月实际完成情况`"
        align="center"
      >
        <!-- 要事进度评价 -->
        <el-table-column
          prop="somethingImportantProgressEvaluation"
          label="要事进度评价"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-if="
                editField === 'somethingImportantProgressEvaluation' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.somethingImportantProgressEvaluation"
              placeholder="请选择"
              filterable
              clearable
              size="mini"
              automatic-dropdown
              @visible-change="visibleChange"
              @change="confirmEdit"
            >
              <el-option label="完成" value="完成"></el-option>
              <el-option label="未完成" value="未完成"></el-option>
            </el-select>
            <div v-else>
              {{ scope.row.somethingImportantProgressEvaluation }}
            </div>
          </template>
        </el-table-column>
        <!-- 实际完成日期 -->
        <el-table-column
          prop="actualCompletionDate"
          label="实际完成日期"
          min-width="110px"
          align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-if="
                editField === 'actualCompletionDate' &&
                  editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.actualCompletionDate"
              type="date"
              value-format="MM-dd"
              format="MM-dd"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @change="confirmEdit"
            >
            </el-date-picker>
            <div v-else>
              {{ scope.row.actualCompletionDate }}
            </div>
          </template>
        </el-table-column>
        <!-- 实际交付物 -->
        <el-table-column
          prop="actualDeliverables"
          label="实际交付物"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'actualDeliverables' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.actualDeliverables"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.actualDeliverables }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 差距描述 -->
      <el-table-column
        prop="gapDescription"
        label="差距描述"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'gapDescription' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.gapDescription"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.gapDescription }}
          </div>
        </template>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column label="操作" align="center" width="90px" fixed="right">
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateImportantEventApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      queryParams: {},
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data, queryParams = {}) {
      this.tableData = data || [];
      this.queryParams = { ...queryParams };
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        somethingImportantType: "", // 要事类别
        workItem: "", // 工作项
        completionDate: "", // 完成日期
        deliverables: "", // 交付物
        somethingImportantProgressEvaluation: "", // 要事进度评价
        actualCompletionDate: "", // 实际完成日期
        actualDeliverables: "", // 实际交付物
        gapDescription: "", // 差距描述
        remark: "" // 备注
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(callBack) {
      try {
        const submitData = {
          ...this.queryParams,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateImportantEventApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
          callBack();
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
